import { useEffect, useMemo } from "react";
import { Link, useLocation, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import ImageAddress from "../../Component/Gallery/ImageAddress.json";

export default function GalleryHome() {
  const { t } = useTranslation();
  const location = useLocation();
  const { lang: langParam } = useParams();

  // زبان از URL
  const seg = location.pathname.split("/")[1];
  const lang = langParam || (seg === "fa" || seg === "en" ? seg : "en");

  const withLang = (to) => `/${lang}${to.startsWith("/") ? to : `/${to}`}`;

  // نرمالایز مسیر تصویرها (فرض: public/assets)
  const normalizePath = (p) => {
    if (!p) return "/assets/placeholder.png";
    if (/^https?:\/\//i.test(p)) return p;
    if (p.startsWith("/")) return p;
    const replaced = p.replace(/^(\.\.\/)+assets\//, "/assets/");
    return replaced.startsWith("/assets/") ? replaced : `/assets/${replaced}`;
  };

  // انتخاب سورس بر اساس زبان: imageGroupsFA / imageGroupsEN / fallback: imageGroups
  const groups = useMemo(() => {
    const all =
      lang === "fa"
        ? ImageAddress.imageGroupsFA || ImageAddress.imageGroups || []
        : ImageAddress.imageGroupsEN || ImageAddress.imageGroups || [];
    return all.slice(-4).reverse(); // آخرین ۴ تا، جدیدترین اول
  }, [lang]);

  // انیمیشن ورود
  useEffect(() => {
    const targets = document.querySelectorAll(".fade-in");
    if (!("IntersectionObserver" in window)) {
      targets.forEach((el) => el.classList.add("visible"));
      return;
    }
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("visible");
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.1 }
    );
    targets.forEach((el) => observer.observe(el));
    return () => observer.disconnect();
  }, []);

  return (
    <section
      className="col-xs-12 pl-0 pr-0 pt-5 pb-5"
      style={{ background: "#fff" }}
      dir={lang === "en" ? "ltr" : "rtl"}
    >
      <div className="galleryhome">
        <div className="container">
          <div className="col-xs-12 noPadding">
            <h2 className="text-blue1 mb-3">{t("galleryHome.title")}</h2>
          </div>

          <div className="col-xs-12 col-md-12 noPadding">
            {groups.map((g) => {
              const id = g.imageId || g.id;
              const title = g.title || t("galleryHome.untitled", "Untitled");
              return (
                <div
                  className="col-xs-12 col-md-3 fade-in from-bottom delay-1"
                  key={id}
                >
                  <div className="gallerybox">
                    <Link to={withLang(`/gallery/${id}`)}>
                      <img
                        src={normalizePath(g.imageCover)}
                        className="img-responsive"
                        alt={title}
                        loading="lazy"
                      />
                      <h3 className="text-truncate">{title}</h3>
                    </Link>
                  </div>
                </div>
              );
            })}
          </div>

          {/* لینک مشاهده همه */}
          <div className="col-xs-12 noPadding mt-3">
            <Link className="btn_blue" to={withLang("/gallery")}>
              {t("galleryHome.viewAll")}
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}
